export const ACCOUNT_ROUTES = {
  SETTINGS: '/account/settings'
} as const;
